import { render, staticRenderFns } from "./oilOrderDetail.vue?vue&type=template&id=2a6fd9b3&"
import script from "./oilOrderDetail.vue?vue&type=script&lang=js&"
export * from "./oilOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a6fd9b3')) {
      api.createRecord('2a6fd9b3', component.options)
    } else {
      api.reload('2a6fd9b3', component.options)
    }
    module.hot.accept("./oilOrderDetail.vue?vue&type=template&id=2a6fd9b3&", function () {
      api.rerender('2a6fd9b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/saleDetail/oilOrderDetail.vue"
export default component.exports